/** 
 * Translated from enum com.dataiku.dip.eda.worksheets.models.BinningMode
 * Via: UIModel annotation in the class hierarchy
 */
export enum BinningMode {
    AUTO = "AUTO",
    FIXED_NB = "FIXED_NB",
    FIXED_SIZE = "FIXED_SIZE",
    CUSTOM = "CUSTOM",
}